module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="chatWidget js-open-intercom-chat">\n    <i class="chatWidget__icon"></i>\n    <span class="chatWidget__text">Написать в чат</span>\n</div>';
}
return __p;
};
